import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../auth.service';
import { LiffService } from '../liff.service';
import { OrdersAccessService } from '../orders-access.service';

/**
 * 會員頁僅開放具訂貨權限的 HCP 使用。
 */
export const MemberAccessGuard: CanActivateFn = async () => {
  const router = inject(Router);
  const authService = inject(AuthService);
  const liffService = inject(LiffService);
  const ordersAccessService = inject(OrdersAccessService);

  const validatedIdentity = await ordersAccessService.validateOrdersIdentity(
    liffService.profile.userId,
    authService.customToken
  );

  if (
    !validatedIdentity.entryEnabled ||
    validatedIdentity.identityType !== 'hcp' ||
    !validatedIdentity.hcpProfile?.canOrder
  ) {
    return router.createUrlTree(['/orders/blocked']);
  }

  return true;
};
